import { useEffect } from "react";
import { Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { NavLink, Route, Routes } from "react-router";
import styled from "styled-components";
import Account from "../../containers/Account/Account";
import ProjectsList from "../../containers/ProjectsList/ProjectsList";
import logo2 from "../../images/Ischebeck_Logo2013_VarA_RGB_1zu1_trans.svg";
import ischebeck_logo_de from "../../images/mikropfahl-online-bemessung.jpg";
import ischebeck_logo_en from "../../images/mikropfahl-online-bemessung_EN.jpg";
import ischebeck_logo_es from "../../images/mikropfahl-online-bemessung_ES.jpg";
import {
  BemessungenMikropfaehle,
  selectBemessungenMikropfaehle,
} from "../../store/slices/bemessungenMikropfaehleSlice";
import { logOut } from "../../store/slices/auth/authSlice";
import { setIgnoreMobile } from "../../store/slices/appTitanSlice";
import AashtoAussere from "../Calculations/Aashto/Aussere/Aussere";
import AashtoInnere from "../Calculations/Aashto/Innere/Innere";
import FHWAInnere from "../Calculations/FHWA/Innere/Inner";
import FHWAAussere from "../Calculations/FHWA/Aussere/Outer";
import Aussere from "../Calculations/Aussere/Aussere";
import Innere from "../Calculations/Innere/Innere";
import PileHeadConstruction from "../Calculations/PileHeadConstruction/PileHeadConstruction";
import LVText from "../Calculations/LVText/LVText";
import EpdCalculator from "../Calculations/EpdCalculator/EpdCalculator";
import Deckblatt from "../Deckblatt/Deckblatt";
import BerechnungNavigation from "../Navigation/BerechnungNavigation";
import PdfExportPage from "../PdfExportPage/PdfExportPage";
import LVExportPage from "../LVExportPage/LVExportPage";

export default function Main() {
  const { t, i18n } = useTranslation("translation");
  const bemessungenMikropfaehle = useSelector(selectBemessungenMikropfaehle);
  const dispatch = useDispatch();

  function getBemessungenMikropfaehleAsString() {
    let value = `(${t("navigation.BemessungenMikropfaehleSubtext")} `;
    if (Number(bemessungenMikropfaehle) === BemessungenMikropfaehle.AASHTO)
      value += t("deckblatt.aashto");

    if (Number(bemessungenMikropfaehle) === BemessungenMikropfaehle.GERMANY)
      value += t("deckblatt.germany");

    if (Number(bemessungenMikropfaehle) === BemessungenMikropfaehle.EUROCODE_7)
      value += t("deckblatt.eurocode");

    if (Number(bemessungenMikropfaehle) === BemessungenMikropfaehle.FHWA)
      value += t("deckblatt.fhwa");

    return value + ")";
  }

  function chooseInnereVersion() {
    if (Number(bemessungenMikropfaehle) == BemessungenMikropfaehle.AASHTO) {
      return <AashtoInnere />;
    } else if (Number(bemessungenMikropfaehle) == BemessungenMikropfaehle.FHWA) {
      return <FHWAInnere />;
    } else {
      return <Innere />;
    }
  }

  function chooseAussereVersion() {
    if (Number(bemessungenMikropfaehle) == BemessungenMikropfaehle.AASHTO) {
      return <AashtoAussere />;
    } else if (Number(bemessungenMikropfaehle) == BemessungenMikropfaehle.FHWA) {
      return <FHWAAussere />;
    } else {
      return <Aussere />;
    }
  }

  function RouteToPileheadConstruction() {
    // Not activated / does not exist for now.
    if (Number(bemessungenMikropfaehle) === BemessungenMikropfaehle.AASHTO) {
      return null;
    }

    return <Route path="pile" element={<PileHeadConstruction />} />;
  }

  useEffect(() => {
    chooseAussereVersion();
    chooseInnereVersion();
  }, [bemessungenMikropfaehle]);

  return (
    <div className="temp">
      <div className="container-fluid">
        <div className="row">
          <nav id="sidebarMenu" className="col-md-3 col-lg-2 d-md-block sidebar collapse p-0">
            <div className="position-sticky d-flex flex-column min-vh-100">
              <div className="">
                <Image
                  className="logo"
                  src={
                    i18n.language == "de-DE"
                      ? ischebeck_logo_de
                      : i18n.language == "es-ES"
                        ? ischebeck_logo_es
                        : ischebeck_logo_en
                  }
                  alt=""
                />
              </div>
              <div className="links navigation-links flex-column mb-auto">
                <ul className="nav flex-column pt-3 ">
                  <li key={1} className="nav-item navbar-text">
                    <NavLink to="/application" end>
                      {t("navigation.coverSheet")}
                      <SubText>{getBemessungenMikropfaehleAsString()}</SubText>
                    </NavLink>
                  </li>
                  <li key={2} className="nav-item navbar-text">
                    <NavLink to="/application/innere">
                      {t("navigation.entry1.innerLoadCarryingCapacity")}

                      {Number(bemessungenMikropfaehle) !== BemessungenMikropfaehle.AASHTO &&
                        Number(bemessungenMikropfaehle) !== BemessungenMikropfaehle.FHWA && (
                          <>
                            <div key={1}>{` - ${t(
                              "navigation.entry1.bucklingCalculations"
                            )} `}</div>
                            <div key={2}>{` - ${t("navigation.entry1.fatiqueVerification")} `}</div>
                          </>
                        )}
                    </NavLink>
                  </li>
                  <li key={3} className="nav-item navbar-text">
                    <NavLink to="/application/aussere">
                      {t("navigation.entry2.outerLoadCarryingCapacity")}

                      {Number(bemessungenMikropfaehle) !== BemessungenMikropfaehle.AASHTO &&
                        Number(bemessungenMikropfaehle) !== BemessungenMikropfaehle.FHWA && (
                          <>
                            <div key={1}>{` - ${t("navigation.entry2.pilegroup")} `}</div>
                            <div key={2}>{` - ${t("navigation.entry2.transmissionLength")} `}</div>
                          </>
                        )}
                    </NavLink>
                  </li>
                  {Number(bemessungenMikropfaehle) !== BemessungenMikropfaehle.AASHTO &&
                    Number(bemessungenMikropfaehle) !== BemessungenMikropfaehle.FHWA && (
                      <li key={4} className="nav-item navbar-text">
                        <NavLink to="/application/pile">
                          {t("navigation.pileHeadConstruction")}
                        </NavLink>
                      </li>
                    )}
                  {Number(bemessungenMikropfaehle) === BemessungenMikropfaehle.GERMANY && (
                    <li key={5} className="nav-item navbar-text">
                      <NavLink to="/application/lvtext">{t("navigation.lvText")}</NavLink>
                    </li>
                  )}
                  {/* {Number(bemessungenMikropfaehle) !==
                    BemessungenMikropfaehle.AASHTO &&
                    Number(bemessungenMikropfaehle) !==
                      BemessungenMikropfaehle.FHWA && (
                      <li key={6} className="nav-item navbar-text">
                        <NavLink to="/application/epdCalculator" end>
                          {"CO"}
                          <sub>2</sub>{t("navigation.epdCalculator")}
                        </NavLink>
                      </li>
                    )} */}
                </ul>
              </div>
              <div
                style={{
                  textAlign: "center",
                  backgroundColor: "white",
                  padding: "50px 0 50px 0",
                }}
              >
                <Image className="logo1" src={logo2} alt="" />
              </div>
            </div>
            {/* <div className="sidebar-bottom-logo"> */}
          </nav>

          <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4 p-0">
            <BerechnungNavigation />

            <Routes>
              <Route path="/" element={<Deckblatt />} />
              <Route path="innere" element={chooseInnereVersion()} />
              <Route path="aussere" element={chooseAussereVersion()} />
              {RouteToPileheadConstruction()}
              <Route path="lvtext" element={<LVText />} />
              <Route path="createpdf" element={<PdfExportPage />} />
              <Route path="createlv" element={<LVExportPage />} />
              <Route path="/account/*" element={<Account />} />
              <Route path="/projects/*" element={<ProjectsList />} />
              {/* <Route path="epdCalculator" element={<EpdCalculator />} /> */}
            </Routes>
          </main>
        </div>
      </div>
    </div>
  );
}

export const SubText = styled.p`
  && {
    margin: unset;
    font-style: italic;
    font-size: 12px;
    color: #000;
  }
`;

export const LogoutButton = styled.button`
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: transparent;
  color: #000;
  border: none;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s ease;
  z-index: 1000;
  border-radius: 0;

  &:hover {
    background: #ffeb00;
  }
`;
